import Search from '@commons/search'
import Column from '@components/column'
import Typography from '@components/typography'
import Circle from '@components/circle'
import Svg from '@components/svg'
import { StyleSearchWrapper, StyleSearchItem, StyleWrapper } from './style'
import { useState, useRef, useEffect } from 'react'
import { User } from '@apis'
import { useSelector } from 'react-redux'
const PatientSearch = ({ handleClickPatient, selectedItem }) => {
  const { items: patients } = useSelector((state: any) => state.searchPatients)
  const dropdownRef = useRef<HTMLDivElement>(null)
  const [visible, setVisible] = useState(false)
  const submitHandler = async (search: string) => {
    await User.list({
      params: {
        page: 1,
        limit: 12,
        role: 'patient',
        search,
      },
      state: 'searchPatients',
    })
      .then(() => {
        setVisible(true)
      })
      .catch(() => {})
  }

  const onClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setVisible(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', onClickOutside)
    return () => {
      document.removeEventListener('mousedown', onClickOutside)
    }
  }, [])

  return (
    <Column rowGap={20}>
      <StyleWrapper ref={dropdownRef}>
        <Search onSubmit={submitHandler} />
        {!!visible && (
          <>
            {!!patients?.length ? (
              <StyleSearchWrapper onClick={handleClickPatient}>
                {patients?.map((patient: any) => {
                  return (
                    <StyleSearchItem
                      key={patient?.id}
                      data-cross-id={patient?.id}
                    >
                      <Circle size={25} bg={'inputBorder'}>
                        <Svg svg="search" size={14} color={'placeholder'} />
                      </Circle>
                      <Typography content={patient?.name} size={14} tc="text" />
                      {patient?.id == selectedItem && (
                        <Svg svg={'circleTick'} color={'secondary'} size={14} />
                      )}
                    </StyleSearchItem>
                  )
                })}
              </StyleSearchWrapper>
            ) : (
              <Typography
                content="Not Patient Found"
                styleText="padding-top:10px;"
                size={14}
                tc="placeholder"
              />
            )}
          </>
        )}
      </StyleWrapper>
    </Column>
  )
}

export default PatientSearch
